export default __webpack_public_path__ + "static/media/doitnow.d39feecb.svg";